import { IUseGraphqlWatchQueryOptions } from '@proscom/prostore-apollo-react';
import {
  QUERY_GET_DOCUMENT_SECTIONS,
  QUERY_GET_DOCUMENT_SECTIONS_IN_WELCOME_PAGE
} from '../queries/documentSections';
import { DocumentSectionType } from '../types';
import { useAuthGraphqlQuery } from '../../common/hooks/utils/useAuthGraphqlQuery';

const documentSectionsQueryOptions: IUseGraphqlWatchQueryOptions<
  {},
  DocumentSectionType[]
> = {
  query: QUERY_GET_DOCUMENT_SECTIONS,
  mapData: (result) => result.documentSections
};

export const useDocumentSections = () => {
  return useAuthGraphqlQuery({
    queryOptions: documentSectionsQueryOptions,
    variables: {}
  });
};

const documentSectionsInWelcomePageQueryOptions: IUseGraphqlWatchQueryOptions<
  {},
  DocumentSectionType[]
> = {
  query: QUERY_GET_DOCUMENT_SECTIONS_IN_WELCOME_PAGE,
  mapData: (result) => result.employmentDocumentSections
};

export const useDocumentSectionsInWelcomePage = () => {
  return useAuthGraphqlQuery({
    queryOptions: documentSectionsInWelcomePageQueryOptions,
    variables: {}
  });
};
